import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/useUserServicePatchHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import RiderIcons from "../../Icons/RiderIcons";
const RiderListComponent = loadable(
  () => import("../../components/Rider/RiderList")
);

const RiderList = () => {
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["driver"],
    navigateURL: null,
  });

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.USER}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsEnableEmail = async (value: boolean, id: any) => {
    const payload = {
      is_enable_email: value,
    };
    const url = `${APIS.DRIVER}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsEnableSMS = async (value: boolean, id: any) => {
    const payload = {
      is_enable_sms: value,
    };
    const url = `${APIS.DRIVER}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <RiderIcons />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Rider</span>
      </div>
      <RiderListComponent
        handleIsActive={handleIsActive}
        handleIsEnableEmail={handleIsEnableEmail}
        handleIsEnableSMS={handleIsEnableSMS}
      />
    </>
  );
};

export default RiderList;
